// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pecgyjvzvqjyjzauutlg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlY2d5anZ6dnFqeWp6YXV1dGxnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0NTIzODYsImV4cCI6MjA2NTAyODM4Nn0.lIn_ADFjYx9aZYbEplPuCbiF0bJWMLO_wkBrpbEZk2k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);